import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from '@/tenant/applications/application/root'

export const experienceRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/experience',
    component: lazyRouteComponent(() => import('./Experience'), 'Experience'),
    loader: ({ parentMatchPromise }) => parentMatchPromise,
})
